import type { ReactNode } from 'react';
import type { JobDetail } from '@nest-recruit/shared';
import { ModuleGate } from '../../../../components/ModuleGate';
import { useCanView } from '../../../../stores/session';
import { PostingsTab } from '../hub/PostingsTab';

/**
 * Owner 2026-11-01: Form links sit under Application form in the job setup, not as a tab. They are optional and no part of opening
 * the job. Who sees them is the same as before: the Career site module on, and the right to see postings.
 */
export function FormLinks({ job }: { readonly job: JobDetail }): ReactNode {
  const canSeePostings = useCanView('posting');
  if (!canSeePostings) return null;
  return (
    <ModuleGate module="career_site">
      <PostingsTab detail={job} />
    </ModuleGate>
  );
}
